import styled from 'styled-components'

export const AccordionTitle = styled.p`
  font-family: 'Poppins';
  font-weight: 600 !important;
  font-size: 13px !important;
  color: #000000;
  letter-spacing: 0.2px !important;
`
